import { Button } from "@/components/atoms/Button";
import { Card, CardContent } from "@/components/atoms/Card";
import { Empty } from "@/components/atoms/Empty";
import EmptyReview from "@/components/atoms/Icon/emptyReview";
import { Paragraph } from "@/components/atoms/Paragraph";
import type { IEmptyStateRateAndReviewProps } from "@/components/organisms/AppRateAndReview/types";
import { useAuthUser } from "@/hooks/common/useAuthUser";
import { useTranslations } from "@/hooks/common/useTranslations";

const EmptyStateRateAndReview = ({
  onClickWriteReview,
}: IEmptyStateRateAndReviewProps) => {
  const { t } = useTranslations("SingleAppPage");
  const { isLogged } = useAuthUser();
  const text = t(isLogged ? "writeReview" : "signInToReview");

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-4 items-center justify-center px-4 py-10 ">
          <Empty
            title={t("noReviewsYet")}
            description={t("beTheFirstOne")}
            icon={<EmptyReview />}
          />
          <Button>
            <Paragraph
              size="base"
              fontWeight="medium"
              onClick={onClickWriteReview}
            >
              {text}
            </Paragraph>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default EmptyStateRateAndReview;
